import * as Icons from 'react-icons/si';
import { VscVscode } from 'react-icons/vsc';

export const ChipIconMap = {
  React: Icons.SiReact,
  TypeScript: Icons.SiTypescript,
  'Node.js': Icons.SiNodedotjs,
  Yarn: Icons.SiYarn,
  Git: Icons.SiGit,
  Vercel: Icons.SiVercel,
  Jest: Icons.SiJest,
  Expo: Icons.SiExpo,
  'React Native': Icons.SiReact,
  Xcode: Icons.SiXcode,
  'Android Studio': Icons.SiAndroidstudio,
  'Chakra UI': Icons.SiChakraui,
  Unity: Icons.SiUnity,
  '.NET': Icons.SiDotnet,
  Aseprite: Icons.SiAseprite,
  npm: Icons.SiNpm,
  JavaScript: Icons.SiJavascript,
  'C#': Icons.SiSharp,
  HTML5: Icons.SiHtml5,
  CSS3: Icons.SiCss3,
  Redis: Icons.SiRedis,
  'VS Code': VscVscode,
};
